<template>
	<div>
		<v-card v-if="block.jobs[0].group" class="pa-1">
			<v-card-actions>
				<a>
					<span class="font-weight-bold">
						{{ block.jobs[0].code }}
					</span>
				</a>

				<v-spacer />

				<v-menu offset-y>
					<template v-slot:activator="{ on }">
						<v-btn
							class="right"
							small
							icon
							v-on="on"
							@click="clickSelect(stage.status, block.jobId)"
						>
							<v-icon>mdi-chevron-double-right</v-icon>
						</v-btn>
					</template>

					<v-list>
						<v-list-item
							v-for="(item, index) in nextStatus"
							:key="index"
							@click="
								changeStatusManual(item.status, stage.status, block.jobId)
							"
						>
							<v-list-item-title>{{ item.status }}</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
			</v-card-actions>
			<div class="pl-2">
				{{ block.jobs[0].account.name }}
			</div>
			<v-tooltip bottom v-if="block.jobs[0].qtEstAndReal">
				<template v-slot:activator="{ on, attrs }">
					<div class="text-right ma-2" v-on="on" v-bind="attrs">
						<v-icon color="blue">mdi-progress-check</v-icon>
						<span
							color="info"
							class="font-weight-black"
							style="font-size: 0.875rem;"
						>
							{{ qtEstAndRealInGroup.qtEstimated }} /
							{{ qtEstAndRealInGroup.qtReal }}</span
						>
					</div>
				</template>
				<span>Est / Real</span>
			</v-tooltip>
			<div v-for="job in block.jobs" :key="job.id">
				<v-card color="grey lighten-4" class="pa-1 ml-3 mb-1">
					<a @click="$emit('job-click', job.id)">
						<span class="font-weight-bold">{{ job.code }}</span>
					</a>
					<div>
						<span v-if="job.description && job.description.length < 100">
							{{ job.description }}
						</span>
						<span v-else> {{ job.description.substring(0, 100) }}... </span>
					</div>
					<v-spacer />
					<v-tooltip bottom v-if="job.qtEstAndReal">
						<template v-slot:activator="{ on, attrs }">
							<div class="text-right" v-on="on" v-bind="attrs">
								<v-icon color="blue">mdi-progress-check</v-icon>
								<span
									color="info"
									class="font-weight-black"
									style="font-size: 0.875rem;"
								>
									{{ job.qtEstAndReal.qtEstimated }} /
									{{ job.qtEstAndReal.qtReal }}</span
								>
							</div>
						</template>
						<span>Est / Real</span>
					</v-tooltip>
				</v-card>
			</div>
		</v-card>

		<v-card v-else>
			<v-card-actions>
				<a @click="$emit('job-click', block.jobId)">
					<span class="font-weight-bold">
						{{ block.jobs[0].code }}
					</span>
				</a>
				<v-spacer />
				<v-menu offset-y>
					<template v-slot:activator="{ on }">
						<v-btn
							class="right"
							small
							icon
							v-on="on"
							@click="clickSelect(stage.status, block.jobId)"
						>
							<v-icon>mdi-chevron-double-right</v-icon>
						</v-btn>
					</template>
					<v-list>
						<v-list-item
							v-for="(item, index) in nextStatus"
							:key="index"
							@click="
								changeStatusManual(item.status, stage.status, block.jobId)
							"
						>
							<v-list-item-title>{{ item.status }}</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
			</v-card-actions>
			<v-card-text>
				<div v-if="block.jobs[0].account">
					<span>
						{{ block.jobs[0].account.name }}
					</span>
				</div>

				<span
					v-if="
						block.jobs[0].description && block.jobs[0].description.length < 100
					"
				>
					{{ block.jobs[0].description }}
				</span>

				<span v-else>
					{{ block.jobs[0].description.substring(0, 100) }}...
				</span>

				<v-spacer />
				<v-tooltip bottom v-if="block.jobs[0].qtEstAndReal">
					<template v-slot:activator="{ on, attrs }">
						<div class="text-right" v-on="on" v-bind="attrs">
							<v-icon color="blue">mdi-progress-check</v-icon>
							<span color="info" class="font-weight-black">
								{{ block.jobs[0].qtEstAndReal.qtEstimated }} /
								{{ block.jobs[0].qtEstAndReal.qtReal }}</span
							>
						</div>
					</template>
					<span>Est / Real</span>
				</v-tooltip>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
	export default {
		props: {
			block: {},
			stage: {},
			stages: {},
		},
		data() {
			return {
				statusSelected: null,
				jobIdSelected: null,
			};
		},
		computed: {
			nextStatus() {
				if (!this.statusSelected) return [];
				return this.stages.filter((s) => s.status != this.statusSelected);
			},
			qtEstAndRealInGroup() {
				const jobs = this.block.jobs;
				let qtReal = 0;
				let qtEstimated = 0;

				jobs.forEach((job) => {
					if (!job.qtEstAndReal) return;
					qtReal += job.qtEstAndReal.qtReal;
					qtEstimated += job.qtEstAndReal.qtEstimated;
				});
				return { qtReal, qtEstimated };
			},
		},
		methods: {
			clickSelect(status, jobId) {
				this.statusSelected = status;
				this.jobIdSelected = jobId;
			},

			changeStatusManual(nextStatus, previousStatus, jobId) {
				this.clickSelect(status, jobId);
				this.$emit("update-block", {
					blockId: JSON.stringify({ id: jobId }),
					nextStatus,
					previousStatus,
				});
			},
		},
		mounted() {},
	};
</script>

<style></style>
